<template lang="pug">
  div(class="container")  
    v-row(v-if="slider").px-4
      v-flex(xs12 md8 lg8)
        v-slider(label="Time Scale:" v-model="tick" :tick-labels="timescale" :max="years-1" step="1" ticks="always" tick-size="6" @click="replot").pr-4
      v-flex(xs12 md4 lg4)
        v-slider(label="Duration:" v-model="duration" thumb-label="always" :max="maxDuration" :min="1" @click="replot")
     
    line-chart(v-if="loaded" :chartdata="chartdata" :options="options" :key="componentkey")

    div(class="text-center" v-if="!loaded").mt-12
      v-progress-circular(indeterminate class="mb-2" :size="50" :width="5" color="primary")
</template>

<script>
//Importing Line class from the vue-chartjs wrapper
import lineChart from "../LineChart";
import moment from "moment";

//Exporting this so it can be used in other components
export default {
  name: "WazeTraffic",
  props: ["slider", "groupby", "duration", "startyear"],
  components: { lineChart },
  data: () => ({
    loaded: false,
    componentkey: 0,
    chartdata: Object,
    now: moment().format("YYYY-MM-DD HH:mm:ss"),
    years: 4,
    timescale: [],
    tick: Number,
    maxDuration: 48,
    options: {}
  }),
  async mounted() {
    this.timescale = this.slider
      ? [...Array(this.years).keys()].map(() => --this.startyear + 1).sort()
      : [];
    this.tick = this.timescale.length - 1;
    this.getData()
      .then(this.sortData)
      .then(this.plotData);
  },

  methods: {
    replot() {
      this.maxDuration = (this.tick + 1) * 12;
      this.getData()
        .then(this.sortData)
        .then(this.plotData)
    },
    getData() {
      return new Promise(resolve => {
        fetch(
          `https://datahub-v2.arlingtonva.us/api/Waze/AlertsGroupedByMonth?$skip=${Math.abs(
            this.tick - this.timescale.length + 1
          ) * this.duration}&$top=${this.duration*2}&$filter=alertTypeCode eq 'JAM' or alertTypeCode eq 'ACCIDENT'`
        ).then(response => {
          resolve(response.json());
        });
      });
    },

    sortData(data) {
      return Object.values(data).sort(function(a, b) {
        return new Date(a.monthdate) - new Date(b.monthdate);
      });
    },

    plotData(data) {
      this.chartdata = {
        //Data to be represented on x-axis
        labels: [
          ...new Set(data.map(d => moment.utc(d.monthdate).format("MMM YYYY")))
        ],
        datasets: [
          {
            label: "Traffic Jams",
            borderColor: "#005cb8",
            borderWidth: 3,
            pointBackgroundColor: "white",
            //pointBorderColor: "#E53935",
            fill: false,
            //Data to be represented on y-axis
            data: [
              ...data
                .filter(alerts => {
                  return alerts.alertTypeCode === "JAM";
                })
                .map(d => d.alerts)
            ]
          },
          {
            label: "Accidents",
            borderColor: "#f87979",
            borderWidth: 3,
            pointBackgroundColor: "white",
            //pointBorderColor: "#005cbb",
            fill: false,
            //Data to be represented on y-axis
            data: [
              ...data
                .filter(alerts => {
                  return alerts.alertTypeCode === "ACCIDENT";
                })
                .map(d => d.alerts)
            ]
          }
        ]
      };

      this.options = {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: true,
                labelString: "Alerts"
              }
            }
          ],
          xAxes: [
            {
              ticks: {},
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: true,
                labelString: "Period"
              }
            }
          ]
        },
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      };

      this.componentkey += 1;
      this.loaded = true;
    }
  }
};
</script>